import axios from 'axios';
import resolve  from '../resolver.js';
import checkJwt from '../../Global/jwtChecker' 
import logout from '../../Global/logout'

export default async function GetProviderUsers(
    activePage, 
    pageSize, 
    orderByColumn, 
    sortDirection,
    searchFor,
    dateFrom,
    dateTo
    ) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    
    let queryData = "?page=" + activePage + 
    "&size=" + pageSize + "&sortDirection=" + sortDirection + "&searchFor=" + searchFor + "&export=t"

    if(orderByColumn !== null){
        queryData += "&orderByColumn=" + orderByColumn
    }

    if(dateFrom !== ""){
        queryData += "&fromDate=" + dateFrom
    }

    if(dateTo !== ""){
        queryData += "&toDate=" + dateTo
    }
  

    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/user/transactionsList' + queryData /*+ '&orderByColumn=created&sortDirection=desc&searchFor='*/ , {
            method: 'GET',
            headers: { 'Authorization' : unHashedJwt}         
        }).then(
            res => (res)
        ).catch(error => error.response)
    )
}